/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MaterialTable from 'material-table';
import { Button, Link, Typography } from '@material-ui/core';
import moment from 'moment';
import uiActions from '../../redux/actions/uiActions';
import evaluoExamServices from '../../redux/services/evaluoExamServices';
import { Loading } from '../../helpers/utils';

const EvaluoExam = ({ userData, group }) => {
  const [evaluoExams, setEvaluoExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await evaluoExamServices.getEvaluoExamsByCompanyAndStudent(
        userData.company._id,
        group.semester,
        userData.evaluoId,
      );
      if (res.message) {
        setLoading(false);
      } else {
        const examsArr = [];
        res.forEach((exam) => {
          if (exam.users && exam.users.length > 0) {
            exam.users.forEach((user) => {
              if (user.user.email === userData.email) {
                examsArr.push(exam);
              }
            });
          }
        });
        const sortedArr = examsArr.sort((a, b) => {
          if (a.temporality.start_at < b.temporality.start_at) {
            return -1;
          }
          if (a.temporality.start_at > b.temporality.start_at) {
            return 1;
          }
          return 0;
        });
        setEvaluoExams(sortedArr);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEvaluoExams([]);
    if (group.semester === userData.semester || userData.catchUp?.includes(group.semester)) {
      getData();
    }
  }, [group]);

  const handleToken = async (url) => {
    const res = await evaluoExamServices.getEvaluoUserToken(userData.evaluoId, url);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.target = '_blank';
    a.href = res;
    a.click();
    a.remove();
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '90%',
          marginTop: '30px',
        }}
      >
        {loading
          ? <Loading />
          : (
            <MaterialTable
              title="Examens Evaluo"
              data={evaluoExams}
              columns={[
                {
                  title: 'Nom',
                  field: 'name',
                },
                {
                  title: 'Début',
                  field: 'temporality.start_at',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{moment(new Date(temporality.start_at)).format('DD/MM/YYYY à HH:mm')}</Typography>
                  ),
                },
                {
                  title: 'Fin',
                  field: 'temporality.end_at',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{moment(new Date(temporality.end_at)).format('DD/MM/YYYY à HH:mm')}</Typography>
                  ),
                },
                {
                  title: 'Durée',
                  field: 'temporality.duration',
                  render: ({ temporality }) => (
                    <Typography variant="body2">{temporality.duration}</Typography>
                  ),
                },
                {
                  title: 'Examen',
                  field: 'temporality.duration',
                  render: (rowData) => (
                    <Button
                      variant="contained"
                      color="primary"
                      disableElevation
                      onClick={() => {
                        const url = rowData.user.state.name === 'Terminé'
                          ? `/testStudent/show?id=${rowData.id}`
                          : `/takeExam/index?id=${rowData.id}`;
                        handleToken(url);
                      }}
                    >
                      {rowData.user.state.name === 'Terminé' ? 'Voir copie' : 'Passer examen'}
                    </Button>
                  ),
                },
              ]}
              localization={{
                body: {
                  emptyDataSourceMessage: `Pas d'examen prévu pour le semestre ${group.semester}`,
                },
              }}
            />
          )}
      </div>
    </div>
  );
};

EvaluoExam.propTypes = {
  userData: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
};

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
};

function mapState(state) {
  const { currentGroup } = state.ui;
  const { data } = state.group;
  const { userData } = state.user;
  return {
    userData,
    group: data[currentGroup],
  };
}

export default connect(mapState, actionCreators)(EvaluoExam);
